import { DataBean } from "../../DataBean";


export class HealthProduct extends DataBean {


    public async getHealthProductCatalog(type:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthProductCatalog_Number_String_Number_Number", [type,regexStr,page,recordsPerPage]);
    }


}